@if (kirjanpitajaOnDevaajaObservable | async) {
  <div style="padding-bottom: 20px">
    <h3 style="margin: 0">Urit</h3>
    <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
      Käyttäjän tallentamat tiedot: <a [href]="erittelyEncodedUriObservable | async" target="_BLANK">{{ erittelyUriObservable | async }}</a>
    </div>
  </div>
}

@if (taseDataObservable | async; as data) {
  <div style="display: flex; justify-content: space-between">
    <app-icon-button (click)="downloadPdf()" actionId="Lataa tase-erittely koneelle">
      <div class="pdf-btn">
        <div>PDF</div>
        <mat-icon style="font-size: 14px; height: 15px; line-height: 15px">save_alt</mat-icon>
      </div>
    </app-icon-button>
    @if (!data.lukittu) {
      <form>
        <div style="text-align: right">
          Tee erittely päivälle
          <mat-form-field style="max-width: 110px">
            <input style="text-align: center" type="text" [matDatepicker]="loppuuPicker" [min]="minLoppuuDateObservable | async" [max]="maxLoppuuDateObservable | async" [formField]="lomake.loppuu" placeholder="Päivä" matInput data-lpignore="true" (dateChange)="tallennaLoppuu()" />
            <mat-datepicker-toggle matSuffix [for]="loppuuPicker"></mat-datepicker-toggle>
            <mat-datepicker #loppuuPicker></mat-datepicker>
          </mat-form-field>
          <app-primary-button (click)="tallennaLoppuu()" actionId="Tee tase-erittely päivälle" [actionContext]="[lomake().value()]" styles="margin-left: 10px;"> Tallenna </app-primary-button>
        </div>
      </form>
    }
  </div>
  @if (!ladataan()) {
    @if (data.lukittu) {
      <div style="padding: 3em; font-weight: bold">Tilinpäätös on rekisteröity. Tietoja ei voi enää muokata.</div>
    }
    <div class="save-status">
      @if (saveSuccessObservable | async) {
        <span>
          <span [@quickInSlowOut]="'in'" style="color: gray"> Lomake tallennettiin </span>
          <mat-icon class="save-success-icon" [@quickInSlowOut]="'in'" [ngStyle]="{ color: '#4bd76b', 'vertical-align': 'middle' }">done</mat-icon>
        </span>
      }
    </div>
    @if (data.c == 'c2' || data.c == 'c1') {
      <table class="report-table" (click)="handleClick($event, data)">
        <thead>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>{{ data.c1?.e | lnumberpvml: 'fi' }}</td>
            <td></td>
          </tr>
        </thead>
        @for (row of data.r; track trackAccountRowByAccountNumberFn($index, row)) {
          <tbody [attr.data-a]="row.a">
            <tr [attr.data-tnro]="row.a" class="report-row-lvl-{{ row.l }} report-row-acc-nmbr-length-{{ row.a.length }} report-acc-row" [class.report-row-expanded]="row.e" [class.report-row-sum]="row.s">
              <td>
                @if (row.a.length > 3) {
                  <select [disabled]="data.lukittu" [value]="row.kasittely" (change)="tilinKasittelyMuuttui($any($event.target).value, row)">
                    <option value="e">Ei eritellä</option>
                    <option value="k">Kaikki tilikaudet</option>
                    <option value="r">Raportin tilikausi</option>
                    <option value="re">Reskontraerittely</option>
                    <option value="v">Viimeinen kuukausi</option>
                    <option value="l">Erillinen liite</option>
                    <option value="t">Oma teksti</option>
                  </select>
                }
              </td>
              <td class="n" colspan="5">
                <div>{{ row.n }}</div>
                @if (row.kasittely === 're') {
                  <div style="font-weight: bold">Erillisen liitteen mukaan</div>
                }
              </td>
              <td>{{ row.s1 | number: '1.2-2' }}</td>
              <td>
                @if (!data.lukittu && (row.kasittely === 'v' || row.kasittely === 'r' || row.kasittely === 'k')) {
                  <input type="checkbox" [matTooltip]="'Valitse kaikki'" (change)="valitseKaikkiMuuttui($any($event.target).checked, row)" />
                }
              </td>
            </tr>
            @if (row.kasittely === 're') {
              <tr class="report-row-lvl-{{ row.l }} report-table-detail-row">
                <td></td>
                <td colspan="7">
                  <app-button (click)="lataaReskontraErittelyPdf(row.a)" actionId="Lataa pdf koneelle (reskontra)">
                    <div class="pdf-btn">
                      <div>PDF</div>
                      <mat-icon style="font-size: 14px; height: 15px; line-height: 15px">save_alt</mat-icon>
                    </div>
                  </app-button>
                </td>
              </tr>
            }
            @if (row.kasittely === 't') {
              <tr class="report-row-lvl-{{ row.l }} report-table-detail-row">
                <td></td>
                <td colspan="7">
                  <mat-form-field style="width: 95%; margin-left: 5%">
                    <mat-label>Oma teksti</mat-label>
                    <textarea [disabled]="data.lukittu" [value]="row.teksti ?? ''" (input)="tilinTekstiMuuttui($any($event.target).value, row)" (blur)="autosave()" matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="100"></textarea>
                  </mat-form-field>
                </td>
              </tr>
            }
            @if (row.e && row.d == undefined) {
              <tr class="report-row-lvl-{{ row.l }} report-table-detail-row">
                <td></td>
                <td colspan="7">
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </td>
              </tr>
            }
            @if (row.kasittely === 'l') {
              <tr class="report-row-lvl-{{ row.l }}">
                <td></td>
                <td colspan="7">
                  <app-button actionId="Valitse tiedosto: Lisää erillinen liite (tase-erittely)">
                    <label style="cursor: pointer" [for]="'fileInput-' + row.a"> + Lisää erillinen liite </label>
                  </app-button>
                  <input [id]="'fileInput-' + row.a" type="file" style="display: none" accept="*" multiple (change)="lataa($event, row.a)" />
                  <div class="attachment-wrapper">
                    @for (attachment of cachedAttachmentsMap.get(row.a); track attachment) {
                      <div class="attachment-row">
                        @if (!attachment.poistettu) {
                          <app-icon-button (click)="deleteAttachment(attachment, row.a)" actionId="Poista liite (tase-erittely)" additionalClass="remove-btn small-icon-button">
                            <i class="icon ion-ios-trash icon-btn"></i>
                          </app-icon-button>
                          <div class="attachment-text">{{ attachment.nimi }}</div>
                          <!-- <div class="attachment-size"> {{ attachment.koko > (100 * 1000) ? ((attachment.koko / (1000 * 1000)) | ldecimall: 1 : 'fi') : ((attachment.koko / (1000 * 1000)) | ldecimall: 3 : 'fi') }} MT</div> -->
                          <!-- <button class="lataa-pdf-button" type="button" type="button">
                          <i class="fa fa-file-pdf-o"></i>
                        </button> -->
                        }
                      </div>
                    }
                  </div>
                </td>
              </tr>
            }
            @if (row.e && row.d) {
              <ng-container class="report-row-lvl-{{ row.l }} report-table-detail-row">
                @if (row.d.length == 0) {
                  <tr>
                    <td></td>
                    <td colspan="7">Tilille ei löytynyt yhtään vientiä.</td>
                  </tr>
                }
                @if (row.d.length > 0) {
                  <tr class="alkusaldo report-row-lvl-{{ row.l }} report-table-detail-row harmaa" [class.valittu]="row.alkusaldoValittu">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>Alkusaldo</td>
                    <td></td>
                    <td></td>
                    <td>{{ row.o1 | number: '1.2-2' }}</td>
                    <td>
                      <input [disabled]="data.lukittu" type="checkbox" [checked]="row.alkusaldoValittu" (change)="alkusaldonValintaMuuttui($any($event.target).checked, row)" />
                    </td>
                  </tr>
                  @for (d of row.d; track trackDetailRowByKirjausNumeroFn(i, d); let i = $index) {
                    <tr [attr.data-i]="i" class="report-row-lvl-{{ row.l }} report-table-detail-row harmaa" [class.laajennettu]="d.l" [class.valittu]="d.valittu">
                      <td></td>
                      <td [class.projekti-dot]="d.b" [class]="d.b ? 'a' + d.b : null" [attr.data-n]="d.n">{{ d.n }}</td>
                      <td>{{ d.p | lnumberpvmlnarrow: 'fi' }}</td>
                      <td>
                        @if (d.a) {
                          <span class="blue-text">{{ d.a }}</span>
                        }
                        @if (d.c) {
                          <span class="cursive-text">{{ d.c }}</span>
                        }
                        {{ d.r }} {{ d.e }}
                      </td>
                      <td>{{ d.d | number: '1.2-2' }}</td>
                      <td>{{ d.k | number: '1.2-2' }}</td>
                      <td>{{ d.s | number: '1.2-2' }}</td>
                      <td>
                        <input [disabled]="data.lukittu" type="checkbox" [checked]="d.valittu" (change)="vienninValintaMuuttui($any($event.target).checked, row, d, i)" />
                      </td>
                    </tr>
                  }
                  <tr class="report-row-lvl-{{ row.l }} report-table-detail-row yhteensa">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td colspan="3">
                      {{ row.valittuSumma | number: '1.2-2' }}
                      @if (row.valittuSumma != row.s1) {
                        <div style="color: red; font-weight: bold">Erottaa {{ row.s1 - row.valittuSumma | number: '1.2-2' }}</div>
                      }
                    </td>
                    <td></td>
                  </tr>
                }
              </ng-container>
            }
            @if (row.s && (row.a === '1' || row.a === '2')) {
              <tr class="report-row-lvl-{{ row.l }} report-table-detail-row">
                <td colspan="3">
                  <mat-form-field style="width: 95%; margin-left: 5%">
                    <mat-label style="text-transform: none">Vapaa teksti</mat-label>
                    <textarea [disabled]="data.lukittu" [value]="row.teksti ?? ''" (input)="tilinTekstiMuuttui($any($event.target).value, row)" (blur)="autosave()" matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="100"></textarea>
                  </mat-form-field>
                </td>
              </tr>
            }
          </tbody>
        }
      </table>
    }
    @if (latausVirheObservable | async; as latausVirhe) {
      <div #latausvirhe class="red-text" style="margin: 20px 0">{{ latausVirhe }}</div>
    }
    <div style="text-align: right; padding: 30px 0">
      @if (!data.lukittu) {
        <app-primary-button (click)="tallenna(data)" [disabled]="!!(latausVirheObservable | async)" actionId="Tallenna tase-erittely"> Tallenna </app-primary-button>
      }
    </div>
  } @else {
    <mat-spinner style="margin-left: auto; margin-right: auto; margin-top: 20px"></mat-spinner>
  }
}

<!-- <input #fileInput type="file" style="visibility: hidden;" accept="*" multiple (change)="lataa($event)" /> -->
